import React from "react";
import Modal from "react-bootstrap/Modal";
import "../assets/styles/VideoModal.css";
import Close from '../assets/images/close.png'

export default function VideoModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body>
        <div className="video-container">
          <div style={{marginLeft:'auto', marginRight:'5px', cursor:'pointer'}} onClick={onHide} >
            <img src={Close} alt='close' style={{height:'12px', width:'12px'}} />
          </div>
          <iframe 
            width="100%" 
            height="200" 
            src="https://www.youtube.com/embed/VjL11VQ7LG0" 
            title="YouTube video player" 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen
          ></iframe>
        </div>
      </Modal.Body>
    </Modal>
  );
}

